// src/pages/administrativo/ConfigTEFSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useConfigTEF } from '../../contexts/administrativo/ConfigTEFContext'; // Contexto de ConfigTEF
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const ConfigTEFSearch = ({ show, onHide, onSelectConfigTEF }) => {
    const { configTEFList } = useConfigTEF(); // Contexto de Configuração de TEF
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id'); // 'id' ou outro campo relevante
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' ou 'desc'
     // Quantidade de itens por página

    const inputRef = useRef(null); // Referência para o input

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) {
                inputRef.current.focus(); // Aplica o foco no input quando o modal abrir
            }
        }
    }, [show]);

    if (!show) return null;

    // Filtra as configurações de TEF por um campo relevante (exemplo: "nome" ou "identificador")
    const filteredConfigTEF = configTEFList.filter(config =>
        (config.nomeTerminal || '').toLowerCase().includes(filter.toLowerCase()) // Ajuste o campo conforme o modelo
    );

    // Ordena as configurações de TEF de acordo com o campo e direção selecionados
    const sortedConfigTEF = filteredConfigTEF.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'nomeTerminal') { // Ajuste o campo conforme o modelo
            const nameA = (a.nomeTerminal || '').toLowerCase();
            const nameB = (b.nomeTerminal || '').toLowerCase();
            if (nameA < nameB) return sortDirection === 'asc' ? -1 : 1;
            if (nameA > nameB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0; // Retorno padrão
    });

    // Divide as configurações de TEF em páginas

    // Número total de páginas

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (configTEF) => {
        onSelectConfigTEF(configTEF);
        onHide();
    };

    return (
        <ModalContainer show={show} largura="600px" variant="busca" onHide={onHide}>

            <ModalHeader title="Buscar Configuração de TEF" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por nome..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedConfigTEF} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable  containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '50%' }} aria-sort={sortField === 'nomeTerminal' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('nomeTerminal')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} type="button">
                                    Nome
                                    {sortField === 'nomeTerminal' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(configTEF => (
                            <tr key={configTEF.id} onDoubleClick={() => handleDoubleClick(configTEF)}>
                                <td className="text-end align-middle">{configTEF?.id}</td>
                                <td className="align-middle">{configTEF?.nomeTerminal}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectConfigTEF(configTEF)} label={configTEF?.nomeTerminal} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>

        </ModalContainer>
    );
};

export default ConfigTEFSearch;
